import { Pane, Text } from 'evergreen-ui';
import useWindowSize from '../../../utils/useWindowSize';
import { cleanNotes } from '../../../utils/turniAbsences';
import MonthDayBadges from './MonthDayBadges';

const GIORNI_SETTIMANA = ['LUN', 'MAR', 'MER', 'GIO', 'VEN', 'SAB', 'DOM'];

const isToday = (day) => day.fullDate === new Date().toISOString().split('T')[0];

function HiddenDay({ day, dIdx, isMobile }) {
  if (!isMobile) {
    return (
      <Pane border="none" padding={8} background="tint1" borderRadius={4} opacity={0.5} minHeight={100} display="flex" alignItems="center" justifyContent="center">
        <Text size={300} color="muted" fontWeight="bold">Giornata coperta</Text>
      </Pane>
    );
  }
  return (
    <Pane border="none" padding={12} background="tint1" borderRadius={8} opacity={0.5} display="flex" justifyContent="space-between" alignItems="center">
      <Pane display="flex" alignItems="baseline" gap={8}>
        <Text size={500} fontWeight="bold">{day.date}</Text>
        <Text size={300}>{GIORNI_SETTIMANA[dIdx % 7]}</Text>
      </Pane>
      <Text size={300} color="muted" fontWeight="bold">COPERTO</Text>
    </Pane>
  );
}

export default function VistaMensile({
  mockDays,
  showOnlyUncovered,
  turniData,
  managerFerieList,
  reperibilitaData,
  getInitials,
  getBadgeProps,
  handleDrop,
  handleDayClick,
  setShiftInputs,
  shiftInputs,
  setIsTurnoModalOpen,
  onShiftDragStart,
  onLeaveDragStart,
}) {
  const isMobile = useWindowSize() < 768;

  const onShiftClick = (s) => {
    setShiftInputs({
      ...shiftInputs, id: s.id, date: s.date, operator_name: s.operator_name,
      start_time: s.start_time || '', end_time: s.end_time || '', shift_type: s.shift_type,
      shift_period: s.shift_period || '', notes: cleanNotes(s.notes), is_overtime: !!s.is_overtime,
    });
    setIsTurnoModalOpen(true);
  };

  const renderBadges = (day) => (
    <MonthDayBadges
      day={day} turniData={turniData} managerFerieList={managerFerieList} reperibilitaData={reperibilitaData}
      isMobile={isMobile} getInitials={getInitials} getBadgeProps={getBadgeProps}
      onShiftDragStart={onShiftDragStart} onLeaveDragStart={onLeaveDragStart} onShiftClick={onShiftClick}
    />
  );

  if (isMobile) {
    return (
      <Pane display="flex" flexDirection="column" gap={12}>
        {mockDays.map((day, dIdx) => {
          if (!day) return null;
          if (showOnlyUncovered && day.status === 'coperto') return <HiddenDay key={`hidden_${day.date}`} day={day} dIdx={dIdx} isMobile />;
          return (
            <Pane key={day.date} border="default" borderRadius={8} padding={16} background={isToday(day) ? 'tint1' : 'white'}
              onClick={() => handleDayClick(day)} cursor="pointer" display="flex" flexDirection="column" gap={12}>
              <Pane display="flex" alignItems="baseline" gap={8} borderBottom="muted" paddingBottom={8}>
                <Text size={500} fontWeight="bold">{day.date}</Text>
                <Text size={300}>{GIORNI_SETTIMANA[dIdx % 7]}</Text>
              </Pane>
              {renderBadges(day)}
            </Pane>
          );
        })}
      </Pane>
    );
  }

  return (
    <Pane display="grid" gridTemplateColumns="repeat(7, minmax(90px, 1fr))" gap={8}>
      {GIORNI_SETTIMANA.map(g => (
        <Pane key={g} textAlign="center" paddingY={8} background="tint2" borderRadius={4}>
          <Text fontWeight="bold">{g}</Text>
        </Pane>
      ))}
      {mockDays.map((day, dIdx) => {
        if (!day) return <Pane key={`empty_${dIdx}`} background="tint1" border="none" minHeight={100} />;
        if (showOnlyUncovered && day.status === 'coperto') return <HiddenDay key={`hidden_${day.date}`} day={day} dIdx={dIdx} />;
        return (
          <Pane key={day.date} minHeight={100} border="default" padding={8} background={isToday(day) ? 'tint1' : 'white'}
            onDragOver={e => e.preventDefault()} onDrop={e => handleDrop(e, day.fullDate)}
            onClick={() => handleDayClick(day)} cursor="pointer" hoverElevation={2}>
            <Text size={300} fontWeight="bold">{day.date}</Text>
            {renderBadges(day)}
          </Pane>
        );
      })}
    </Pane>
  );
}
